module.exports = __webpack_public_path__ + "static/media/599.7554(13).922b7beb.pdf";